import React from 'react';
import { API_BASE } from '../../config';
import { useTranslation } from 'react-i18next';

export default function StravaConnectButton({ redirectPath = null, className = '' }) {
  const { t } = useTranslation();
  const onClick = () => {
    // Prefer redirecting back to the current page after OAuth, so the user can continue where they left off.
    // Keep a fallback in localStorage for older callback flows.
    const redirectTo = redirectPath ? `${window.location.origin}${redirectPath}` : window.location.href;
    try {
      localStorage.setItem('runcoach_post_oauth_redirect', window.location.href);
    } catch {
      // Ignore storage errors (private mode, etc.)
    }
    window.location.href = `${API_BASE}/auth/strava/start?redirect_to=${encodeURIComponent(redirectTo)}`;
  };

  return (
    <button
      onClick={onClick}
      className={
        className ||
        'inline-flex items-center justify-center bg-orange-600 text-white font-bold py-2 px-4 rounded-lg shadow hover:bg-orange-700 transition'
      }
      type="button"
    >
      {t('wizard.connect_strava')}
    </button>
  );
}


